import React from 'react'
import { IconButton, Modal } from '@mui/material'
import styles from './NewWedingModal.module.scss'
import { Box } from '@mui/material'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'

function NewWedingModal({
	open,
	handleClose,
	children,
	modalBody,
	className,
	handleBack,
	modalImage,
}) {
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	}
	return (
			<Modal
				open={open}
				onClose={(event, reason) => {
					if (reason === 'backdropClick') return
					handleClose()
				}}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				className={`${styles.modalWrp} ${className || ''}`}
				sx={{ zIndex: 2000 }}
			>
                <Box sx={style} className={`${styles.modalInner}`}>
                    {modalImage && (
                        <figure className={`${styles.modalImage}`}>
                            <img src={modalImage} alt={modalImage} />
                        </figure>
                    )}
                    <div className={`${styles.modalBody} ${modalBody}`}>
                        <div className="">
                            {handleBack && (
                                <IconButton
                                    sx={{
                                        color: 'white',
                                        position: 'absolute',
                                        backgroundColor: '#ffffff',
                                        borderRadius: '50%',
                                        padding: '12px',
                                        left: '1rem',
                                        top: '1rem',
                                        zIndex: 3,
                                        '@media (max-width: 499px)': {
                                            padding: '8px',
                                        },
                                    }}
                                    onClick={handleBack}
                                >
                                    <ArrowBackOutlinedIcon
                                        sx={{
                                            color: '#282828',
                                            width: '20px',
                                            height: '20px',
                                            aspectRatio: '1/1',
                                        }}
                                    />
                                </IconButton>
                            )}
                            <IconButton
                                data-cy="wizard-modal-close"
                                sx={{
                                    color: 'white',
                                    position: 'absolute',
                                    backgroundColor: '#ffffff',
                                    borderRadius: '50%',
                                    padding: '12px',
                                    right: '1rem',
                                    top: '1rem',
                                    zIndex: 3,
                                    '@media (max-width: 499px)': {
                                        padding: '8px',
                                    },
                                }}
                                onClick={handleClose}
                            >
                                <img
                                    src="/images/modal-close-icon.svg"
                                    alt=""
                                />
                            </IconButton>
                        </div>
                        {children}
                    </div>

                    <div className={`${styles.bgImg}`}>
                        <img
                            src="/images/clock-img.png"
                            alt="clock-img.png"
                        />
                    </div>
                </Box>
			</Modal>
	)
}

export default NewWedingModal
